import {Link} from 'react-router-dom'
import {routes} from '../../routes'
import {useSelector} from 'react-redux'
import classNames from 'classnames'
import NavigationHelper from '../../utils/navigation'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const EmptyIntegration = ({close}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const text = useNamespaceTranslations('resource-integrations')

    return (
        <div className={classNames('modal-body no-integration-modal', {
            dark: isDarkMode
        })}>
            <span className="desc">{text.integration_desc}</span>
            <div className="buttons">
                <button className="light-bg cancel-button" onClick={close}>{text.cancel}</button>
                <Link className="simple-blue-button" to={NavigationHelper.getLocalizedPath(routes.integrations.paths)}>
                    {text.go_to_integrations}
                </Link>
            </div>
        </div>

    )
}

export default EmptyIntegration
